import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      borderWidth: ['base', 'thin'],
    },
    classGroups: {
      'blur': ['blur', 'blur-0', 'blur-sm', 'blur-xs', 'blur-md', 'blur-lg', 'blur-xl', 'blur-2xl'],
      'font-size': [
        'text-display-sm', 'text-display-md', 'text-display-lg',
        'text-heading-sm', 'text-heading-md', 'text-heading-lg',
        'text-sm', 'text-md', 'text-lg',
        'text-base',
      ],
    }
  }
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
